module.exports = __webpack_public_path__ + "static/media/rdsr_multi.e1d6cad6.svg";